import React from 'react';
import Navbar from '@/components/landing/Navbar';
import HeroSection from '@/components/landing/HeroSection';
import DemoVideoSection from '@/components/landing/DemoVideoSection';
import ProblemSection from '@/components/landing/ProblemSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import WhyChooseSection from '@/components/landing/WhyChooseSection';
import VeriFactuSection from '@/components/landing/VeriFactuSection';
import PricingSection from '@/components/landing/PricingSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import FAQSection from '@/components/landing/FAQSection';
import CTASection from '@/components/landing/CTASection';
import Footer from '@/components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <HeroSection />
        <DemoVideoSection />
        <ProblemSection />
        <FeaturesSection />
        <WhyChooseSection />
        <VeriFactuSection />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
